import type { ReactNode } from 'react';

interface ProviderDirectoryLayoutProps {
  children: ReactNode;
}

/**
 * Shared layout wrapper for the redesigned Provider Directory.
 * Provides consistent padding, max-width, and background within MainLayout's Outlet.
 */
export const ProviderDirectoryLayout = ({
  children,
}: ProviderDirectoryLayoutProps) => {
  return (
    <div className="h-full overflow-y-auto bg-background">
      <div className="mx-auto max-w-5xl px-6 py-6">{children}</div>
    </div>
  );
};
